import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Popover, Modal, Input } from "antd";

import {
  InterestAction,
  PhotoreqAction,
  ShortlistAction,
  BlocklistAction,
  MyNotesAction,
  OthersProfileAction,
} from "../../../store/actions";

import CardBottomButton from "../../dashboardcard/cardbottombutton";
import { PrimaryButton, WhiteButton } from "../../button";
import Spacer from "../../spacer/spacer";

import EditProfileDropdown from "../../dropdown/editprofiledropdown";
import { reportItems } from "../../../utils/arrayitems";

import images from "../../../assets";

const { TextArea } = Input;
const { confirm } = Modal;

export default function ProfileCompletion() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => {
    return state?.othersProfile?.profile;
  });
  const { interestsAll } = useSelector((state) => state.interests);
  const { photoreqAll } = useSelector((state) => state.photoreq);
  const { shortlistsAll } = useSelector((state) => state.shortlists);

  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
  const [note, setNote] = useState("");
  const [reportState, setReportState] = useState({
    reason: "",
    description: "",
  });
  const [buttonState, setbuttonState] = useState({
    interestSent: false,
    shortlistSent: false,
    photoRequestSent: false,
  });

  useEffect(() => {
    const interestSent = interestsAll?.some(
      (profile) => profile.receiverId === profileData?.username
    );

    const photoRequestSent = photoreqAll?.some(
      (profile) => profile.receiverId === profileData?.username
    );
    const shortlistSent = shortlistsAll?.some(
      (profile) => profile.receiverId === profileData?.username
    );
    setbuttonState({ interestSent, shortlistSent, photoRequestSent });
  }, [interestsAll, photoreqAll, shortlistsAll]);

  useEffect(() => {
    getNote();
    dispatch(ShortlistAction.getShortlistAll());
  }, []);

  const getNote = () => {
    const payload = { username: profileData?.username };
    dispatch(MyNotesAction.getNote(payload));
  };
  const handleSendNote = () => {
    setIsNoteModalOpen(false);
    const payload = { note, receiverId: profileData?.username };
    dispatch(MyNotesAction.setNotes(payload));
  };
  const handleSendInterest = (id) => {
    const payload = {
      receiverId: id,
    };
    dispatch(InterestAction.sendInterest(payload));
  };

  const handleSendPhotoReq = (id) => {
    const payload = {
      receiverId: id,
    };
    dispatch(PhotoreqAction.sendPhotoreq(payload));
  };

  const handleShortlist = (id) => {
    const payload = {
      receiverId: id,
    };
    dispatch(ShortlistAction.sendShortlist(payload));
  };

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleReport = () => {
    const payload = { ...reportState, reportedId: profileData?.username };

    dispatch(
      OthersProfileAction.reportProfile(payload, () => {
        setIsModalOpen(false);
        setReportState({
          reason: "",
          description: "",
        });
      })
    );
  };

  const BlockUserConfirm = () => {
    confirm({
      centered: true,
      icon: <img src={images.deleteIcon} alt="Block" />,
      content: `Are you sure you want to Block ${profileData?.firstName} ${profileData?.lastName}`,
      okText: "Block",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        const payload = { blockedId: profileData?.username };
        dispatch(
          BlocklistAction.updateBlocklist(payload, () => {
            dispatch(
              BlocklistAction.getBlocklist({
                from: 0,
                size: 8,
              })
            );
            navigate("/block-list");
          })
        );
      },
    });
  };

  return (
    <>
      <div className="other-profile-completion">
        <div className="other-profile-completion-bottom">
          <CardBottomButton
            icon={images.cardButtonTick}
            onClick={() => handleShortlist(profileData?.username)}
            title="Shortlist"
            disabled={buttonState?.shortlistSent}
          />
          <CardBottomButton
            icon={images.cardMessage}
            onClick={() =>
              navigate(
                `/messages?username=${profileData?.username}&firstName=${profileData?.firstName}&lastName=${profileData?.lastName}&photo=${profileData?.profilePicture}`
              )
            }
            title="Send Message"
          />
          <CardBottomButton
            icon={images.cardPhotoReq}
            onClick={() => handleSendPhotoReq(profileData?.username)}
            title="Send Photo Request"
            disabled={buttonState?.photoRequestSent}
          />
          <CardBottomButton
            icon={images.cardmatch}
            onClick={() => handleSendInterest(profileData?.username)}
            title="Send Interest"
            disabled={buttonState?.interestSent}
          />

          <Popover
            style={{
              width: "240px",
            }}
            content={
              <div className="other-user-activity">
                <div
                  className="other-user-content"
                  onClick={() => setIsNoteModalOpen(true)}
                >
                  <img src={images.personalNote} alt="" />
                  <p>My personal note</p>
                </div>
                <div onClick={BlockUserConfirm} className="other-user-content">
                  <img src={images.blockUser} alt="" />
                  <p>
                    Block {profileData?.firstName}&nbsp;
                    {profileData?.lastName}
                  </p>
                </div>
                <div
                  onClick={() => setIsModalOpen(true)}
                  className="other-user-content"
                >
                  <img src={images.reportUser} alt="" />
                  <p>Report Activity</p>
                </div>
                <div onClick={hide} className="other-user-content">
                  <img src={images.cancelUser} alt="" />
                  <p>Cancel</p>
                </div>
              </div>
            }
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement="bottomRight"
            arrow={false}
          >
            <div className="three-dotted-btn">
              <img src={images.threeDotted} alt="" />
            </div>
          </Popover>
        </div>
      </div>

      <Modal
        centered={true}
        open={isNoteModalOpen}
        onCancel={() => isNoteModalOpen(false)}
        footer={false}
        closable={false}
        className="forgot-password-modal"
      >
        <h1
          style={{
            position: "absolute",
            top: "10px",
          }}
          className="mynote-header"
        >
          My Notes
        </h1>
        <img
          src={images?.closeIcon}
          className="modal-close-icon"
          alt=""
          onClick={() => setIsNoteModalOpen(false)}
        />
        <div className="user-report-user-content">
          <div className="user-report-body">
            <div className="user-report-heading">
              <p
                style={{
                  color: "#222",
                  fontFamily: " Poppins",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Add your personal note about {profileData?.firstName}&nbsp;
                {profileData?.lastName}
              </p>
            </div>
            <div className="user-report-message">
              <TextArea
                showCount
                maxLength={1000}
                rows="10"
                placeholder="Type your personal note ..."
                onChange={(e) => setNote(e.target.value)}
                value={note}
              />
            </div>
          </div>
          <Spacer height="48px" />
          <div className="user-report-footer">
            <div className="user-report-btn">
              <WhiteButton
                style={{
                  border: "2px solid var #EAE6ED",
                }}
                text={"Close"}
                onClick={() => setIsNoteModalOpen(false)}
              />
              <PrimaryButton text={"Save"} onClick={handleSendNote} />
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        centered={true}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={false}
        closable={false}
        className="forgot-password-modal"
      >
        <img
          src={images?.closeIcon}
          className="modal-close-icon"
          alt=""
          onClick={() => setIsModalOpen(false)}
        />
        <div className="user-report-user-content">
          <div className="user-report-body">
            <div className="user-report-heading">
              <h1>
                Report {profileData?.firstName}&nbsp;
                {profileData?.lastName}’s Activity
              </h1>
            </div>
            <div className="user-report-inputselect">
              <EditProfileDropdown
                placeholder="Please Select"
                data={reportItems}
                onChange={(e) => {
                  setReportState({ ...reportState, reason: e });
                }}
                value={reportState.reason || undefined}
              />
            </div>
            <div className="user-report-message">
              <TextArea
                style={{
                  width: "100%",
                  outline: "none",
                  background: "transparent",
                }}
                onChange={(e) => {
                  setReportState({
                    ...reportState,
                    description: e.target.value,
                  });
                }}
                value={reportState.description}
                showCount
                maxLength={1000}
                rows="10"
                placeholder="Provide additional information ..."
              />
            </div>
          </div>
          <Spacer height="48px" />
          <div className="user-report-footer">
            <div className="user-report-btn">
              <WhiteButton
                style={{
                  height: "40px",
                  width: "120px",
                  borderRadius: "12px",
                  border:
                    "2px solid var(--Color-Content-button-bg-white, #EAE6ED)",
                }}
                text={"Close"}
                onClick={() => setIsModalOpen(false)}
              />
              <PrimaryButton
                style={{
                  height: "40px",
                  width: "120px",
                }}
                onClick={handleReport}
                text={"Save"}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
